module.exports = __webpack_public_path__ + "static/media/forbauset.42729658.m4a";